module.exports = __webpack_public_path__ + "static/media/logo-meep-novo.9f811c87.png";